module.exports = __webpack_public_path__ + "static/media/building2.cf56681f.svg";